import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute7 from '../../app/routes/PrivateRoute7';
import ListStatisticsIntentions from './ListStatisticsIntentions';

const IntentionsStatisticsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PrivateRoute7><ListStatisticsIntentions /></PrivateRoute7>} />
    </Routes>
  );
};

export default IntentionsStatisticsRoutes;
